var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.userWithNotificationSettings)?_c('v-container',{staticClass:"pa-0 layout-container"},[_c('NotificationSettings',{attrs:{"user":_vm.userWithNotificationSettings,"refetch-user":_vm.refetchUser}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }